"use client"

import { ScanHeart } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ScanHeartIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ScanHeartIcon = component(Icon)({ as: ScanHeart })
